var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Knee") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Knee",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.3517427,-1.63973264 C5.22673261,1.00876795 9.27692891,2.78420616 10.7988462,3.68658198 C12.3207635,4.5889578 14.5388661,6.04605364 17.453154,8.05786951 L21.3562973,10.5507801 C22.7119756,11.4968596 23.5476341,12.658069 23.8632728,14.0344084 C24.1789114,15.4107479 24.1789114,16.8574866 23.8632728,18.3746247 C23.7004463,19.8364309 23.5782615,20.7831069 23.4967183,21.2146526 C23.4390121,21.5200477 23.0643945,22.2902685 22.76283,23.7560476 C22.6382616,24.3615223 22.3407136,27.2047123 22.2189462,29.1281888 C22.0971788,31.0516653 20.4490049,40.3465192 20.1803458,43.5488388 C20.0012398,45.6837185 20.0915955,47.8996209 20.4514131,50.196546 L12.4636201,50.8669227 C12.5588749,47.1020708 12.5588749,44.26579 12.4636201,42.3580801 C12.3899731,40.8831202 11.8832324,37.9394074 11.0780912,31.8477445 C10.7988462,29.7349892 11.1897015,25.8624259 11.5879058,24.0471253 C11.98611,22.2318248 13.2311422,20.1043528 13.2959108,19.413216 C13.3390898,18.9524582 13.3390898,18.5440443 13.2959108,18.1879743 C11.7985415,17.8099831 10.7021862,17.5775368 10.0068448,17.4906354 C5.05916986,16.8722916 1.82487368,16.1304773 -0.233244926,15.2583637 C-2.66742668,14.2268958 -5.1730117,12.6577013 -7.75,10.5507801 L-7.75,-1.63973264 L-1.3517427,-1.63973264 Z",
    id: "background",
    fill: "#8596A1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.650000036,
    fill: "#F6F6F6",
    points: "10.9961269 3.74192009 7.52839224 1.72801731 3.53534842 16.3736134 5.78613616 16.9504121"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.650000036,
    fill: "#F6F6F6",
    points: "10.9961269 3.74192009 13.401094 5.27501118 7.78236881 17.4748535 5.78613616 16.9504121"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.650000036,
    fill: "#F6F6F6",
    points: "7.92511901 17.3273178 10.6649825 17.7640642 15.5519408 6.75994954 13.401094 5.27501118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.650000036,
    fill: "#F6F6F6",
    points: "10.6649825 17.7640642 12.9631695 18.4452842 18.8437791 8.94986831 15.5519408 6.75994954"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.650000036,
    fill: "#F6F6F6",
    points: "12.9631695 18.4452842 13.0947599 18.8897033 21.9243558 11.0630925 18.8437791 8.94986831"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.650000036,
    fill: "#F6F6F6",
    points: "13.0947599 18.8897033 23.8189182 20.3340617 23.0753326 23.0587813 12.8536524 20.3340617"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.650000036,
    fill: "#F6F6F6",
    points: "12.8536524 20.3340617 12.348019 21.4546045 22.355125 26.2165057 22.918339 23.2227687"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.650000036,
    fill: "#F6F6F6",
    points: "12.348019 21.4546045 11.4287733 23.6321214 22.2344362 28.0436597 22.355125 26.2165057"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.650000036,
    fill: "#F6F6F6",
    points: "11.4287733 23.6321214 10.9961269 26.2165057 22.2344362 29.5395153 22.2344362 28.0436597"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnee);
export default __webpack_public_path__ + "static/media/Knee.da0c97f38082049611211704b1f9afdc.svg";
export { ForwardRef as ReactComponent };